import { Button } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import type { InsuranceAdvisorAttributes } from "../../../contexts";

export type ChatbotPromptProps = {
  label: string;
  advisorAttributes?: InsuranceAdvisorAttributes;
};

export const ChatbotPrompt = ({
  label,
  advisorAttributes,
}: ChatbotPromptProps) => {
  const classes = classNames("mobius-chatbot-prompt", {
    "sb-iaw": advisorAttributes,
  });

  return (
    <Button
      className={classes}
      size="sm"
      variant="ghost"
      {...advisorAttributes}
      data-value={label}
    >
      {label}
    </Button>
  );
};
